const ImMsgType = {
    TEXT: 'text',
    GRP_TIP: 'grp_tip',
    USER_ENTER: 'user_enter',
    AIVIDEO: 'aivideo'
}

export default ImMsgType;